import Vue from 'vue'
import Router from 'vue-router'

import account from './account'
import artist from './artist'
import fan from './fan'
import discover from './discover'
import content from './content'
import site from './site'

import PageNotFound from '@/components/pages/fan/PageNotFound'

import { requireUserType, requireLogin } from './guard'

Vue.use(Router)

const catchall = [
  { path: '*', name: 'catchall', component: PageNotFound }
]

const router = new Router({
  mode: 'history',
  routes: [].concat(account, fan, artist, discover, content, site, catchall),
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(requireLogin)
router.beforeEach(requireUserType)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js